export const SOCIAL_LOOP_TREND = {
  INCREASE: '#34a853',
  DECREASE: '#ea4335',
};

export const getSocialLoopTrendColor = (isIncrease) =>
  isIncrease ? SOCIAL_LOOP_TREND.INCREASE : SOCIAL_LOOP_TREND.DECREASE;

export const socialLoopCardSx = {
  p: 1.5,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

export const socialLoopHeaderSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: 1,
};

export const socialLoopTitleSx = {
  fontWeight: 'medium',
};

export const socialLoopBodySx = {
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
};

export const socialLoopDescriptionSx = (isIncrease) => ({
  color: getSocialLoopTrendColor(isIncrease),
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.7rem',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const socialLoopDescriptionIconSx = {
  fontSize: 16,
  mr: 0.5,
  flexShrink: 0,
};
